module.exports = __webpack_public_path__ + "img/rightWhite.35015990.svg";